/**
* @name APP u-suite
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: loginController
* # alias: $ctrl
*/

export default class loginController {

	constructor($scope, $state, ngNotify, LOCAL_ENV_CONSTANT, $localStorage, $http, $timeout, Helpers, GlobalSrv, $filter) {
		this.$state = $state
		this.$scope = $scope
		this.ngNotify = ngNotify
		this.$timeout = $timeout
		this.$localStorage = $localStorage
		this.$http = $http
		this.Helpers = Helpers
		this.appConfig = LOCAL_ENV_CONSTANT
		this.$scope.auth2 = {}
		this.$translate = $filter('translate')
		this.userApi = GlobalSrv.userLogin
		this.main()
		
		if (this.$localStorage.userAuth) {
			this.goHomePage()
		}

		$timeout(() => {
			if (this.appConfig.GOOGLE_ACCOUNT_KEY) {
				gapi.load('auth2', $scope.initGoogleSign)
			}
		}, 700)

		$scope.initGoogleSign = () => {
			gapi.auth2.init({ client_id: this.appConfig.GOOGLE_ACCOUNT_KEY })
			this.$scope.auth2 = gapi.auth2.getAuthInstance()
			this.$scope.auth2.isSignedIn.listen($scope.googleSigninChanged)

			if (this.$scope.auth2.isSignedIn.get() == true) {
				this.$scope.auth2.signIn()
			}
		}

		$scope.googleSigninChanged = (isSignedIn) => {
			if (isSignedIn) {
				const GUser = this.$scope.auth2.currentUser.get()
				const AuthResponse = GUser.getAuthResponse()
				const Profile = GUser.getBasicProfile()
				let userLoged = {
					socialId   : Profile.getId(),
					fullName   : Profile.getName(),
					firstName  : Profile.getGivenName(),
					lastName   : Profile.getFamilyName(),
					photo      : Profile.getImageUrl(),
					email      : Profile.getEmail(),
					tokenId    : AuthResponse.id_token,
					sessionTime: AuthResponse.expires_at,
				}

				this.$scope.$digest()

				if (!this.$localStorage.userAuth) {
					this.validateUser(userLoged)
				}
			} else {
				this.$scope.$digest()
			}
		}
	}

	main() {
		const clientName = this.appConfig.clientName

		try {
			this.$scope.clientLogo = require(`../assets/images/logo-${clientName}.svg`)
		} catch (error) {
			this.$scope.clientLogo = require('../assets/images/logo-uplanner.svg')
		}
	}

	validateUser(user) {
		const params = angular.extend({}, user, {
			username   : user.email,
			status     : 1,
			institution: '1',
		})

		this.$scope.isLoading = true
		this.userApi.validUserSocialIntegration(params).$promise.then((response) => {
			if (!response.status) {
				let msn = response.messageError || response.message || this.$translate('MSJ_ERROR')

				this.ngNotify.set(msn, 'warn')
			} else {
				if (response.data.exist || response.inserted) {
					let params = {
						name    : user.email,
						password: '*******',
						type    : 'WEB',
					}

					this.getRequest('', params).success((response) => {
						this.$scope.isLoading = false
						this.saveUser(response)
					})
				}
			}
		}, (err) => {
			this.$scope.isLoading = false
			this.ngNotify.set(this.$translate('ERROR_CLONING_PROCESS') + ' validUserSocialIntegration', 'error')
		})
	}

	goHomePage() {
		const path = this.appConfig.HOMEPAGE.substr(4)

		for (let i in this.$state.get()) {
			if (this.$state.get()[i].url == path) {
				this.$state.go(this.$state.get()[i].name, {}, { reload: this.$state.get()[i].name })

				return
			}
		}
	}

	onSubmit(isValid) {
		if (isValid) {
			let params = {
				name    : this.$scope.loginForm.name.$$rawModelValue,
				password: this.$scope.loginForm.password.$$rawModelValue,
				type    : 'WEB',
			}

			this.getRequest('', params).success((response) => {
				this.saveUser(response)
			})
		} else {
			this.ngNotify.set(this.$translate('MSJ_INCORRECT_USER_PASS'), 'error')
			delete this.$localStorage.userLogin
			delete this.$localStorage.userAuth
		}
	}

	saveUser(response) {
		let data = this.Helpers.getUserStored(response)

		if (data.status) {
			this.$localStorage.userAuth = response
			this.$localStorage.userLogin = data
			this.$localStorage.logintime = Date.now()
			window.location = this.appConfig.HOMEPAGE
		} else {
			this.ngNotify.set(this.$translate('MSJ_INCORRECT_USER_PASS'), 'error')
			delete this.$localStorage.userLogin
			delete this.$localStorage.userAuth
		}
	}

	getRequest(url, params) {
		return this.$http({
			method : 'POST',
			url    : this.appConfig.USER_API_URL + '/api/user-api' + url,
			data   : $.param(params),
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
		})
	}

}

loginController.$inject = [ '$scope', '$state', 'ngNotify', 'LOCAL_ENV_CONSTANT', '$localStorage', '$http', '$timeout', 'Helpers', 'GlobalSrv', '$filter' ]



// WEBPACK FOOTER //
// ./src/login/loginController.js